export default __webpack_public_path__ + "media/src/assets/images/MapPinDelivery-b498fc19795f58344f9a6035e6f95f6f.svg";